import { Stack } from "@mui/material";
import ViewMoreList from "../ViewMoreList";
import PostCard from "./PostCard";
import { posts } from "../../../constants/talent-profile";

export default function PostList() {

  return (
    <ViewMoreList title="Posts" onViewMore={() => {}} maxHeight="1230px">
      <Stack direction="column" gap={2}>
      {posts.map((post, index) => (
        <PostCard
          key={index}
          title={post.title}
          description={post.description}
          mediaType={post.mediaType}
          mediaUrl={post.mediaUrl}
          likes={post.likes}
          comments={post.comments}
          timestamp={post.timestamp}
          onLike={() => {}}
          onComment={() => {}}
          onShare={() => {}}
          />
        ))}
      </Stack>
    </ViewMoreList>
  );
}
